import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'file',
})
export class FilePipe implements PipeTransform {
  url: string = environment.apiURL;

  transform(value: unknown, ...args: unknown[]): string {
    const raw = String(value ?? '');
    const needsAuth = raw.includes('type=documento');
    const token = localStorage.getItem('teatro-colosseo-backoffice-auth-token') || '';
    const sep = raw.includes('?') ? '&' : '?';
    const q = needsAuth && token ? `${sep}token=${encodeURIComponent(token)}` : '';
    return `${this.url}file/${raw}${q}`;
  }
}
